<template>
  <div class="grid grid-cols-2 items-center gap-16">
    <!-- The pieces share one viewBox, so the five layers stack into a whole phone. -->
    <div class="relative aspect-square">
      <RevIllustration
        v-for="part in PHONE_PARTS"
        :key="part"
        :src="`/mine-my-phone/images/smartphone/${part}.svg`"
        :data-active="isActive(part)"
        alt=""
        aria-hidden="true"
        data-piece
        :width="480"
        :height="496"
        class="absolute inset-0 h-full w-full"
      />
    </div>
    <ul class="grid gap-10">
      <li
        v-for="part in PHONE_PARTS"
        :key="part"
        :data-active="isActive(part)"
        class="raw-body-3 flex items-center gap-6"
      >
        <span data-dot class="rounded-full h-8 w-8 shrink-0" />
        <span class="rounded-full bg-[white] px-12 py-4">{{
          i18n(translations[part])
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import type { PhonePart } from '~/scopes/campaign/data/metals/types'

import translations from './PhoneDiagram.translations'

// Five stacked layers, the metal's own lit and the rest ghosted. Split out of
// `SmartphoneSection` so the journey's opening card can carry it without the score.
//
// Display order = the dissection, top to bottom.
const PHONE_PARTS: PhonePart[] = [
  'screen',
  'camera',
  'electronics',
  'battery',
  'casing',
]

const props = defineProps<{ parts: readonly PhonePart[] }>()

const i18n = useI18n()

// Truthy for the metal's parts; `undefined` (not `false`) drops the attribute so
// `:not([data-active])` can mute the rest. Shared by the diagram and the list.
const isActive = (part: PhonePart) => props.parts.includes(part) || undefined
</script>

<style scoped>
[data-piece]:not([data-active]),
li:not([data-active]) {
  opacity: 0.125;
}

[data-dot] {
  display: grid;
  place-items: center;
  background: var(--raw-black);

  &::before {
    content: '';
    height: 2px;
    width: 2px;
    border-radius: 9999px;
    background: white;
  }
}
</style>
